<template>
  <div>

    <div class="bar_nav">
      <div class="title">关于我们</div>
      <div class="bar_back_btn" @click="goToUserSetting">我</div>
    </div>
    <div class="bar_empty"></div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'AboutUs',
  data: function () {
    return {
      password: ''
    }
  },
  async created() {
  },
  methods: {
    async updatePassword() {
      try {
        if (!this.password || this.password.length < 8) {
          return Toast({
            message: '密码不能为空, 且必须至少8位'
          })
        }
        await this.$faApi.updateUserInfo(this.$route.params.userId, {
          password: this.password
        })
        this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
      } catch (err) {
        this.$faLogger.error('EditPassword.vue:updatePassword', err)
      }
    },
    goToUserSetting() {
      this.$router.push({ path: `/user/${this.$route.params.userId}/user_setting` })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
  